import styled, { keyframes } from "styled-components";

const wait = keyframes`
    0%   { left: -7px  }
    30%  { left: 52px  }
    60%  { left: 22px  }
    100% { left: 100px }
`;

export const Loading = styled.div`
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    width: 100px;
    color: grey;
    margin: auto;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);

    & span {
        position: absolute;
        height: 10px;
        width: 84px;
        top: 50px;
        overflow: hidden;
    }

    & span > i {
        position: absolute;
    height: 4px;
    width: 4px;
    border-radius: 50%;
    -webkit-animation: ${wait} 4s infinite;
    -moz-animation: ${wait} 4s infinite;
    -o-animation: ${wait} 4s infinite;
    animation: ${wait} 4s infinite;
    }
    
    & span > i:nth-of-type(1) {
        left: -28px;
        background: #005a24;
    }

    & span > i:nth-of-type(2) {
        left: -21px;
        -webkit-animation-delay: 0.8s;
        animation-delay: 0.8s;
        background: #005a24;
    }
`;